<template>
  <q-card>
    <q-tabs
      v-model="selectedTab"
      dense
      outside-arrows
      mobile-arrows
      :class="
        this.$q.dark.mode === true ? 'bg-grey-10' : 'text-grey-9 bg-grey-4'
      "
      active-color="white"
      :active-bg-color="activeTabColorFromUtils()"
      :indicator-color="activeTabColorFromUtils()"
      align="justify"
      narrow-indicator
    >
      <q-tab name="daily" label="Daily" color="black" no-caps />
      <q-tab name="weekly" label="Weekly" color="black" no-caps />
      <q-tab name="monthly" label="Monthly" color="black" no-caps />
    </q-tabs>
    <q-separator />
    <q-tab-panels v-model="selectedTab" animated>
      <q-tab-panel class="q-pa-none" :name="selectedTab">
        <TopGainers
          :isMarketOn="isMarketOn"
          :tabPeriod="selectedTab"
          :filterTableSeriesDataForGainers="filterTableSeriesDataForGainers"
          :sectorId="selectedSectorId"
          :topGainers="topGainers"
          :topGainersDaily="topGainersDaily"
          :topGainersWeekly="topGainersWeekly"
          :topGainersMonthly="topGainersMonthly"
          :allStocks="allStocks"
        />
        <TopLosers
          class="q-mt-md"
          :isMarketOn="isMarketOn"
          :filterTableSeriesDataForLosers="filterTableSeriesDataForLosers"
          :tabPeriod="selectedTab"
          :sectorId="selectedSectorId"
          :topLosersDaily="topLosersDaily"
          :topLosersWeekly="topLosersWeekly"
          :topLosersMonthly="topLosersMonthly"
          :allStocks="allStocks"
        />
      </q-tab-panel>
    </q-tab-panels>
  </q-card>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { LocalStorage, useQuasar } from "quasar";
import TopLosers from "src/components/TopLosers.vue";
import TopGainers from "src/components/TopGainers.vue";
import { useStore } from "vuex";
import useUtils from "src/use/utils";

export default {
  name: "StockPerformanceDayWise",
  components: { TopLosers, TopGainers },
  props: {
    isMarketOn: {
      type: Boolean,
      required: false,
      default: false,
    },
    selectedSectorId: {
      type: Number,
      required: false,
      default: null,
    },
    topLosers: { type: Array },
    topLosersDaily: { type: Array },
    topLosersWeekly: { type: Array },
    topLosersMonthly: { type: Array },
    topGainers: { type: Array },
    topGainersDaily: { type: Array },
    topGainersWeekly: { type: Array },
    topGainersMonthly: { type: Array },

    allStocks: { type: Array },
  },

  setup(props) {
    let selectedTab = ref("daily");
    const filterTableSeriesDataForGainers = ref([]);
    const filterTableSeriesDataForLosers = ref([]);
    const filterStockData = ref([]);
    const tableSeriesDataForGainers = ref([]);
    const tableSeriesDataForLosers = ref([]);
    const { chooseTabColor, chooseActiveTabColor } = useUtils();

    const $q = useQuasar();
    const store = useStore();
    function chooseColorFromUtils() {
      return chooseTabColor($q.dark.mode, store.state.domain.domain);
    }
    function activeTabColorFromUtils() {
      return chooseActiveTabColor($q.dark.mode, store.state.domain.domain);
    }

    function borderRadius() {
      if (
        store.state.domain.domain.includes(store.state.domain.sweta) ||
        store.state.domain.domain.includes(store.state.domain.arthasarokar) ||
        store.state.domain.domain.includes("prabhu")
      ) {
        return {
          "border-radius": "16px 16px 0px 0px",
        };
      }
    }
    const seriesDataForGainers = () => {
      return props.isMarketOn == true
        ? props.topGainers !== null && props.topGainers
        : selectedTab.value == "daily" && props.topGainersDaily
        ? props.topGainersDaily
        : selectedTab.value == "weekly" && props.topGainersWeekly
        ? props.topGainersWeekly
        : selectedTab.value == "monthly" && props.topGainersMonthly
        ? props.topGainersMonthly
        : [];
    };
    const seriesDataForLosers = () => {
      return props.isMarketOn == true
        ? props.topLosers !== null && props.topLosers
        : selectedTab.value == "daily" && props.topLosersDaily
        ? props.topLosersDaily
        : selectedTab.value == "weekly" && props.topLosersWeekly
        ? props.topLosersWeekly
        : selectedTab.value == "monthly" && props.topLosersMonthly
        ? props.topLosersMonthly
        : [];
    };

    const filterStockPerformanceDataBySector = () => {
      filterStockData.value = props.allStocks?.filter((item) => {
        if (!props.selectedSectorId || props.selectedSectorId == 25)
          return true;
        return (
          item.sector == props.selectedSectorId || props.selectedSectorId == 25
        );
      });

      tableSeriesDataForGainers.value = seriesDataForGainers();
      filterTableSeriesDataForGainers.value =
        tableSeriesDataForGainers.value?.filter((i1) =>
          filterStockData.value?.some((i2) => i1.symbol === i2.symbol)
        );

      tableSeriesDataForLosers.value = seriesDataForLosers();
      filterTableSeriesDataForLosers.value =
        tableSeriesDataForLosers.value?.filter((i1) =>
          filterStockData.value?.some((i2) => i1.symbol === i2.symbol)
        );
    };
    watch(
      () => selectedTab.value,
      (oldVal, newVal) => {
        filterStockPerformanceDataBySector();
      }
    );
    onMounted(() => {
      filterStockPerformanceDataBySector();
    });
    watch(props, (newVal, oldVal) => {
      filterStockPerformanceDataBySector();
    });
    return {
      activeTabColorFromUtils,
      chooseColorFromUtils,
      borderRadius,
      selectedTab,
      filterTableSeriesDataForGainers,
      filterTableSeriesDataForLosers,
      filterStockData,
      tableSeriesDataForGainers,
      tableSeriesDataForLosers,
      seriesDataForGainers,
      seriesDataForLosers,
    };
  },
};
</script>
